import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";
import { IFarmer, IUpdateFarmerPayload } from "../types/farmers";

const API = process.env.REACT_APP_API;

const useUpdateFarmer = () => {
  const fetch = useFetch();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      farmerId,
      data,
    }: {
      farmerId: number;
      data: IUpdateFarmerPayload;
    }) => {
      return fetch(`${API}/api/semeadora/farmers/${farmerId}/`, {
        method: "PATCH",
        body: data,
      }) as Promise<IFarmer>;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["farmers"] });
    },
    onError: (error) => {
      console.error("Erro ao atualizar agricultora", error);
    },
  });
};

export default useUpdateFarmer;
